// / const ENV = "dev";
// let CONSTANTS = {};
// CONSTANTS.ENV = ENV;
// if (ENV === "local") {
//   //
// } else if (ENV === "dev") {
//   CONSTANTS.BACKEND_API_BASEURL = "https://advisory.winwizeresearch.in";
//   CONSTANTS.FRONTEND_BASEURL = "https://advisory.winwizeresearch.in";
// } else if (ENV === "qa") {
//   //
// } else if (ENV === "uat") {
//   //
// } else if (ENV === "prod") {
//   CONSTANTS.BACKEND_API_BASEURL = "";
// }
// export default CONSTANTS;
const ENV = process.env.REACT_APP_ENV || "dev"; // uses build-time env
let CONSTANTS = {};
CONSTANTS.ENV = ENV;
console.log("Running in ENV:", process.env.REACT_APP_ENV);
CONSTANTS.BACKEND_API_BASEURL = "https://advisory.winwizeresearch.in";
CONSTANTS.FRONTEND_BASEURL = "https://advisory.winwizeresearch.in";

// Broker Login API URLs
CONSTANTS.ANGEL_API_URL = "https://smartapi.angelbroking.com/publisher-login?api_key=p0ZP7U6T";
CONSTANTS.ZERODHA_API_URL = "https://kite.zerodha.com/connect/login?v=3&api_key=xe2rjk5vd2equ9xo";
CONSTANTS.ICICI_API_URL = "https://api.icicidirect.com/apiuser/login?api_key={iciciKey}"
console.log("Running in ENV:", process.env.REACT_APP_ENV);
export default CONSTANTS;